export default {
    players: {},
    current: null,

    init(item) {
        const { embedId, provider, id } = item

        if (!document.getElementById(embedId)) {
            return setTimeout(() => this.init(item), 100)
        }

        this.current = this.players[id] = item.provider().init(embedId)

        return this.players[id]
    },

    pauseCurrent() {
        if (this.current !== null) {
            this.current.pause()
        }
    },

    destroy() {
        this.players = {}
        this.current = null
    }
}